export const INTEGRATE_MAGENTO =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/MAGNETO/INTEGRATE'
export const INTEGRATE_MAGENTO_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/MAGNETO/INTEGRATE_SUCCESS'
export const INTEGRATE_MAGENTO_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/MAGNETO/INTEGRATE_ERROR'
